import React, { Component } from "react";
import Button from "react-md/lib/Buttons";
import Link from "gatsby-link";
//import UserLinks from "../UserLinks/UserLinks";
import config from "../../../data/SiteConfig";
import logoPdP from "./pdpblanco.png";
import logoRadioNacional from "./radioblanco.png";
import logoIWMF from "./iwmf.png";
import "./Footer.scss";

class Footer extends Component {
  render() {
    //const url = config.siteRss;
    //const { userLinks } = this.props;
    const copyright = config.copyright;
    const fixedFooter = config.fixedFooter;
    if (!copyright) {
      return null;
    }
    return (
      <footer className={fixedFooter ? "footer footer-fixed" : "footer"}>
        <div className="notice-container">
          <div className="logos-footer">
            <a href="https://www.radionacional.co/" title="Radio Nacional">
              <img src={logoRadioNacional} alt="Radio Nacional" />
            </a>
            <a href="https://piedepagina.mx/" title="Pie de Página">
              <img src={logoPdP} alt="Pie de Página" />
            </a>
            <a href="https://www.iwmf.org/" title="International Women's Media Foundation">
              <img src={logoIWMF} alt="International Women's Media Foundation" />
            </a>
          </div>
          <div className="copyright">
            <h4>{copyright}</h4>
          </div>          
        </div>
      </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js